<template>
  <v-card class="mb-5">
    <v-card-text>
      <template v-if="filters.length <= 0">
        <v-card-text>
          <div class="text-center">Filter belum di tambahkan</div>
        </v-card-text>
      </template>
      <template v-for="(data, i) in filters">
        <template v-if="!data.filters">
          <v-row align="center">
            <v-col lg="2">
              <v-autocomplete
                :label="i == 0 ? 'Where' : 'Tipe'"
                :disabled="i == 0"
                v-model="data.type"
                :items="[
                  {
                    value: 'and',
                    text: 'And',
                  },
                  {
                    value: 'or',
                    text: 'Or',
                  },
                ]"
              ></v-autocomplete>
            </v-col>
            <v-col lg="3">
              <v-autocomplete
                label="Kolom"
                v-model="data.column"
                :items="[
                  {
                    value: 'guru_id',
                    text: 'Guru',
                  },
                  {
                    value: 'ruang',
                    text: 'Ruang',
                  },
                  {
                    value: 'mata_pelajaran_id',
                    text: 'Mata Pelajaran',
                  },
                  {
                    value: 'rombel_id',
                    text: 'Rombel',
                  },
                  {
                    value: 'hari',
                    text: 'Hari',
                  },
                  {
                    value: 'jam_kbm.ke',
                    text: 'Jam KBM',
                  },
                ]"
              ></v-autocomplete>
            </v-col>
            <v-col lg="2">
              <v-autocomplete
                v-if="
                  data.column == 'guru_id' ||
                  data.column == 'mata_pelajaran_id' ||
                  data.column == 'rombel_id' ||
                  data.column == 'hari'
                "
                label="Operasi"
                v-model="data.operator"
                :items="[
                  {
                    value: '=',
                    text: '=',
                  },
                  {
                    value: '!=',
                    text: '!=',
                  },
                ]"
              ></v-autocomplete>
              <v-autocomplete
                v-else-if="data.column == 'jam_kbm.ke'"
                label="Operasi"
                v-model="data.operator"
                :items="[
                  {
                    value: '=',
                    text: '=',
                  },
                  {
                    value: '<',
                    text: '<',
                  },
                  {
                    value: '>',
                    text: '>',
                  },
                  {
                    value: '<=',
                    text: '<=',
                  },
                  {
                    value: '>=',
                    text: '>=',
                  },
                  {
                    value: 'between',
                    text: 'Antara',
                  },
                ]"
              ></v-autocomplete>
              <v-autocomplete
                v-else
                label="Operasi"
                v-model="data.operator"
                :items="[
                  {
                    value: 'like',
                    text: 'Mengandung',
                  },
                  {
                    value: 'not_like',
                    text: 'Tidak mengandung',
                  },
                  {
                    value: 'start_with',
                    text: 'Diawali Dengan',
                  },
                  {
                    value: 'end_with',
                    text: 'Diakhiri Dengan',
                  },
                ]"
              ></v-autocomplete>
            </v-col>
            <v-col lg="4">
              <template v-if="data.column == 'guru_id'">
                <AutoCompleteGuru
                  :value="data.value"
                  @change="
                    (val) => {
                      data.value = val;
                    }
                  "
                />
              </template>
              <template v-else-if="data.column == 'rombel_id'">
                <AutoCompleteRombel
                  :value="data.value"
                  @change="
                    (val) => {
                      data.value = val;
                    }
                  "
                />
              </template>
              <template v-else-if="data.column == 'mata_pelajaran_id'">
                <AutoCompleteMapel
                  :value="data.value"
                  @change="
                    (val) => {
                      data.value = val;
                    }
                  "
                />
              </template>
              <template v-else-if="data.column == 'hari'">
                <v-autocomplete
                  label="Hari"
                  v-model="data.value"
                  :items="[
                    {
                      value: 'senin',
                      text: 'Senin',
                    },
                    {
                      value: 'selasa',
                      text: 'Selasa',
                    },
                    {
                      value: 'rabu',
                      text: 'Rabu',
                    },
                    {
                      value: 'kamis',
                      text: 'Kamis',
                    },
                    {
                      value: 'jumat',
                      text: 'Jumat',
                    },
                    {
                      value: 'sabtu',
                      text: 'Sabtu',
                    },
                  ]"
                ></v-autocomplete>
              </template>
              <template v-else-if="data.column == 'jam_kbm.ke'">
                <v-text-field
                  label="Jam KBM"
                  :placeholder="
                    'Contoh: ' + data.operator == 'antara' ? '1' : '1-12'
                  "
                  v-model="data.value"
                  type="text"
                  max="12"
                  min="1"
                  prefix="Ke-"
                />
              </template>
              <template v-else>
                <v-text-field
                  label="Ketikkan Sesuatu"
                  v-model="data.value"
                  clearable
                ></v-text-field>
              </template>
            </v-col>
            <v-col lg="1">
              <v-btn icon color="red" @click="() => removeFilter(i)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <v-row>
            <template v-if="i != 0">
              <v-col lg="2">
                <v-autocomplete
                  label="Tipe"
                  v-model="data.type"
                  :items="[
                    {
                      value: 'and',
                      text: 'And',
                    },
                    {
                      value: 'or',
                      text: 'Or',
                    },
                  ]"
                ></v-autocomplete>
              </v-col>
            </template>
            <v-col>
              <MultiFilterJadwalMengajar
                :filters.sync="data.filters"
                :type.sync="data.type"
                :remove="() => removeFilter(i)"
                :index="groupIndex + 1"
              />
            </v-col>
          </v-row>
        </template>
      </template>

      <div align="right">
        <v-btn small dark color="darkgray" @click="addFilter">
          <v-icon>mdi-plus</v-icon>
          Filter
        </v-btn>
        <template v-if="groupIndex < 3">
          &nbsp;
          <v-btn small dark color="darkgray" @click="addGroupFilter">
            <v-icon>mdi-plus</v-icon>
            Filter Group
          </v-btn>
        </template>
        <template v-if="groupIndex >= 1">
          &nbsp;
          <v-btn small dark color="red" @click="remove">
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
        </template>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import AutoCompleteGuru from "../AutoCompleteGuru.vue";
import AutoCompleteMapel from "../AutoCompleteMapel.vue";
import AutoCompleteRombel from "../AutoCompleteRombel.vue";

export default {
  props: ["filters", "type", "index", "remove"],
  data() {
    return {
      groupIndex: this.index || 0,
    };
  },
  components: {
    AutoCompleteGuru,
    AutoCompleteMapel,
    AutoCompleteRombel,
    MultiFilterJadwalMengajar: () => import("./MultiFilterJadwalMengajar.vue"),
  },
  methods: {
    addFilter() {
      this.filters.push({
        type: "",
        column: "",
        operator: "",
        value: "",
      });
    },
    removeFilter(index) {
      this.filters.splice(index, 1);
    },
    addGroupFilter() {
      this.filters.push({
        type: "",
        filters: [
          {
            column: "",
            operator: "",
            value: "",
            type: "",
          },
        ],
      });
    },
  },
};
</script>
